import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label", "source"]
  static values = { copiedLabel: String, label: String }

  async copy() {
    const text = this.sourceTarget.textContent.trim()
    let copied = false

    if (navigator.clipboard?.writeText) {
      try {
        await Promise.race([
          navigator.clipboard.writeText(text),
          new Promise((_, reject) => window.setTimeout(() => reject(new Error("Clipboard timeout")), 500))
        ])
        copied = true
      } catch (_error) {
        copied = false
      }
    }

    copied ||= this.copyWithFallback(text)
    if (!copied) return

    this.labelTarget.textContent = this.copiedLabelValue
    window.setTimeout(() => {
      this.labelTarget.textContent = this.labelValue
    }, 2000)
  }

  copyWithFallback(text) {
    const input = document.createElement("textarea")
    input.value = text
    input.setAttribute("readonly", "")
    input.style.position = "fixed"
    input.style.opacity = "0"
    document.body.appendChild(input)
    input.select()
    const copied = document.execCommand("copy")
    input.remove()
    return copied
  }
}
